import { lazy, Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { DemoProvider } from './state';
import { LoginPage } from './pages/LoginPage';
import { RoleGuard } from './layout';
import { ApplicationDeMinimisCheckController, SubmissionDecisionController } from './controllers';
const SigningPopup = lazy(() => import('@/pages/SigningPopup').then((module) => ({ default: module.SigningPopup })));
const WalletPopup = lazy(() => import('@/pages/WalletPopup').then((module) => ({ default: module.WalletPopup })));

const ProjectPage = lazy(() => import('./pages/ProjectPage').then((module) => ({ default: module.ProjectPage })));
const FundingPage = lazy(() => import('./pages/FundingPage').then((module) => ({ default: module.FundingPage })));
const ProofsPage = lazy(() => import('./pages/ProofsPage').then((module) => ({ default: module.ProofsPage })));
const MunicipalityPage = lazy(() => import('./pages/MunicipalityPage').then((module) => ({ default: module.MunicipalityPage })));
const MunicipalityInboxPage = lazy(() => import('./pages/MunicipalityInboxPage').then((module) => ({ default: module.MunicipalityInboxPage })));
const MarketplacePage = lazy(() => import('./pages/MarketplacePage').then((module) => ({ default: module.MarketplacePage })));
const SummaryPage = lazy(() => import('./pages/SummaryPage').then((module) => ({ default: module.SummaryPage })));

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <Suspense fallback={<div role="status">Laster…</div>}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/soknad/prosjekt" element={<RoleGuard role="startup"><ProjectPage /></RoleGuard>} />
        <Route path="/soknad/stotte" element={<RoleGuard role="startup"><FundingPage /></RoleGuard>} />
        <Route path="/soknad/seriøsitet" element={<RoleGuard role="startup"><ProofsPage /></RoleGuard>} />
        <Route path="/soknad/kommuner" element={<RoleGuard role="startup"><MunicipalityPage /></RoleGuard>} />
        <Route path="/soknad/oppsummering" element={<RoleGuard role="startup"><SummaryPage /></RoleGuard>} />
        <Route path="/kommune/innboks" element={<RoleGuard role="municipality"><MunicipalityInboxPage /></RoleGuard>} />
        <Route path="/markedsplass" element={<RoleGuard role="municipality"><MarketplacePage /></RoleGuard>} />
        <Route path="/wallet-popup" element={<WalletPopup />} />
        <Route path="/signing-popup" element={<SigningPopup />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export function InnovasjonNorgeApp() {
  return (
    <DemoProvider>
      <ApplicationDeMinimisCheckController />
      <SubmissionDecisionController />
      <AppRoutes />
    </DemoProvider>
  );
}